// eslint-disable-next-line no-shadow
export enum SupportedLocale {
  Hu = 'hu',
  En = 'en',
}
